// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__G7GMa","mainContent":"App_mainContent__4q3Sx"};